import { render, staticRenderFns } from "./NewDiscountRateNotification.vue?vue&type=template&id=1cfa8e6f&"
import script from "./NewDiscountRateNotification.vue?vue&type=script&lang=js&"
export * from "./NewDiscountRateNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports